module.exports = __webpack_public_path__ + "static/media/nResume12.a42c7552.pdf";